import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { ButtonGroup as k, Button as b, Dropdown as w, DropdownItem as y } from "flowbite-react";
import { o as f } from "../../index-CExbjDCE.js";
import "../Button/Button.js";
import "../Button/ButtonBase.js";
import { buttonGroupTheme as C, buttonTheme as t } from "../Button/theme.js";
import { dropdownButtonTheme as B } from "./theme.js";
const m = {
  blue: "border-l-blue-800 dark:border-l-blue-500",
  dark: "border-l-gray-700 dark:border-l-gray-600",
  failure: "border-l-red-800 dark:border-l-red-500",
  gray: "border-l-gray-300 dark:border-l-gray-600",
  info: "border-l-cyan-800 dark:border-l-cyan-500",
  light: "border-l-gray-300 dark:border-l-gray-500",
  purple: "border-l-purple-800 dark:border-l-purple-500",
  success: "border-l-green-800 dark:border-l-green-500",
  warning: "border-l-yellow-500 dark:border-l-yellow-600",
  outline: "border-l-none",
  glass: "border-l-white dark:border-l-white"
}, H = ({
  label: u,
  onClick: i,
  items: p,
  color: e = "blue",
  size: d = "sm",
  disabled: o = !1,
  className: s = "",
  icon: n,
  dropdownProps: c
}) => {
  const h = m[e] || m.blue;
  return /* @__PURE__ */ a(k, { theme: C, className: s, children: [
    /* @__PURE__ */ a(
      b,
      {
        theme: t,
        color: e,
        size: d,
        className: "border-none",
        disabled: o,
        onClick: i,
        children: [
          n && /* @__PURE__ */ r(n, { className: "mr-2 h-4 w-4" }),
          u
        ]
      }
    ),
    /* @__PURE__ */ r(
      w,
      {
        theme: B,
        disabled: o,
        label: "",
        renderTrigger: () => /* @__PURE__ */ r(
          b,
          {
            theme: t,
            className: `rounded-l-none rounded-r-lg border-l ${h}`,
            color: e,
            size: d,
            disabled: o,
            children: /* @__PURE__ */ r(f, { className: "h-4 w-4" })
          }
        ),
        ...c,
        children: p.map((l, g) => /* @__PURE__ */ r(
          y,
          {
            onClick: l.onClick,
            icon: l.icon,
            children: l.label
          },
          g
        ))
      }
    )
  ] });
};
export {
  H as DropdownButton
};
